module.exports = __webpack_public_path__ + "static/media/person-icon.abfea14f.svg";